import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

export const CONTACT_API_URL = 'https://api.rootsbmd.com/public/SaveContactForm';

export const submitContactForm = async ({
  form,
  successTitle = 'Successful',
  successText = 'Form submitted successfully.',
}) => {
  try {
    const formData = new FormData(form);
    const response = await fetch(CONTACT_API_URL, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      throw new Error('Request failed');
    }

    await Swal.fire({
      icon: 'success',
      title: successTitle,
      text: successText,
      confirmButtonColor: '#fd6219',
    });

    form.reset();
    return true;
  } catch (error) {
    await Swal.fire({
      icon: 'error',
      title: 'Submission failed',
      text: 'Please try again.',
      confirmButtonColor: '#fd6219',
    });
    return false;
  }
};
